import React, { useContext, useEffect, useState } from "react";
import { Info } from "../../assets/media/icons";
import ToastContext from "../../contexts/toast/ToastContext";

interface ToastProps {
  id: number;
}

const Toast: React.FC<ToastProps> = ({ id, children }) => {
  const { removeToast } = useContext(ToastContext);
  const [hiding, setHiding] = useState<boolean>(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setHiding(true);
      setTimeout(() => {
        removeToast(id);
      }, 100);
    }, 3000);

    return () => {
      clearTimeout(timer);
    };
  }, [id, removeToast]);

  return (
    <article
      className={`relative flex items-center w-full p-4 rounded-lg bg-clear-black-75 text-chat-text shadow-lg my-2 pointer-events-none ${
        hiding ? "toast-hiding" : "toast-up"
      }`}
    >
      <Info className="w-5 h-5 flex-shrink-0" />
      <span className="ml-4">{children}</span>
    </article>
  );
};

export default Toast;
